import script from "./BillInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./BillInfoModal.vue?vue&type=style&index=0&id=1a8d85d0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8d85d0"]])

export default __exports__